export default __webpack_public_path__ + "static/media/resume-badge.62609c3e.svg";